import Transformer from '../../transformer'

class WorkerTransformer extends Transformer {
  static fetch(worker) {
    return {
      id: worker.id,
      crewId: worker.crew,
      name: worker.worker.Worker_JBUser_full_name,
      JBuserId: worker.worker.Worker_JBUser_id,
      role: worker.worker.Worker_role,
      roleId: worker.worker.Worker_id,
      workerId: worker.worker.Worker_id,
    }
  }
}

export default class CrewTransformer extends Transformer {
  static fetch(crew) {
    const workers = crew.workers
    return {
      id: crew.id,
      name: crew.name,
      attendantId: (!crew.attendant.attendant_id) ? crew.attendant : crew.attendant.attendant_id,
      attendantName: crew.attendant.attendant_name,
      workers: workers ? WorkerTransformer.fetchCollection(workers) : null
    }
  }
  // TODO: Pending add client data
  static send(crew) {
    return {
      id:crew.id,
      name: crew.name,
      attendant: crew.attendantId,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/crew/crew.js